import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { required } from 'redux-form-validators';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';
import { ReduxSelectField, DefaultButton } from 'common/components';
import { editUserSumsubLevel, getUserSumsubLevels } from '../../_redux';

import { staticStyles } from './style';

const EditUserSumsubLevel = ({
  user,
  handleSubmit,
  pristine,
  submitting,
  invalid,
  dispatch,
  error,
  userSumsubLevels,
  getUserSumsubLevels,
}) => {
  const submit = handleSubmit(values => editUserSumsubLevel({ ...values, userId: user.id }, dispatch));

  const sumsubLevels = userSumsubLevels.map(level => ({
    value: level.name,
    label: level.name,
  }));

  useEffect(() => {
    if (user.id) {
      getUserSumsubLevels(user.id);
    }
  }, [user, getUserSumsubLevels]);

  return (
    <form className="EditUserSumsubLevel" onSubmit={submit}>
      <FormattedMessage id="justChooseSumsubLevel">
        {txt => <p className="EditUserSumsubLevel_description">{txt}</p>}
      </FormattedMessage>
      <div className="EditUserSumsubLevel__inputs-inner">
        <Field
          textId="justSumsubLevel"
          options={sumsubLevels}
          component={ReduxSelectField}
          name="sumsubLevel"
          validate={[required()]}
          disabled={submitting}
          maxMenuHeight={100}
        />
      </div>

      <DefaultButton
        textId="justChange"
        type="submit"
        loading={submitting}
        disabled={invalid || pristine || submitting}
        filled
      />
      {error && <strong className="formError">{error}</strong>}

      <style jsx>{staticStyles}</style>
    </form>
  );
};

EditUserSumsubLevel.propTypes = {
  user: PropTypes.object.isRequired,
  getUserSumsubLevels: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  userSumsubLevels: PropTypes.array,
  error: PropTypes.string,
};

EditUserSumsubLevel.defaultProps = {
  error: '',
  userSumsubLevels: [],
};

export default compose(
  reduxForm({
    form: 'edit-user-sumsub-level',
  }),
  connect(
    state => ({
      userSumsubLevels: state.backoffice.users.userSumsubLevels,
    }),
    {
      getUserSumsubLevels: userId => getUserSumsubLevels.request(userId),
    }
  )
)(EditUserSumsubLevel);
